import React, { useState, useRef, useEffect, useMemo } from "react";
import { NavLink, useLocation } from "react-router-dom";
import sidebarData from "../../config/sidebar";
import { dynamicCommitteesApi } from "../../config/api";

const DashboardIcon = () => <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><rect x="3" y="3" width="7" height="7"></rect><rect x="14" y="3" width="7" height="7"></rect><rect x="14" y="14" width="7" height="7"></rect><rect x="3" y="14" width="7" height="7"></rect></svg>;
const ContentIcon = () => <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path><polyline points="14 2 14 8 20 8"></polyline><line x1="16" y1="13" x2="8" y2="13"></line><line x1="16" y1="17" x2="8" y2="17"></line><polyline points="10 9 9 9 8 9"></polyline></svg>;
const AboutIcon = () => <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="12" cy="12" r="10"></circle><line x1="12" y1="16" x2="12" y2="12"></line><line x1="12" y1="8" x2="12.01" y2="8"></line></svg>;
const AcademicsIcon = () => <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M22 10v6M2 10l10-5 10 5-10 5z"></path><path d="M6 12v5c3 3 9 3 12 0v-5"></path></svg>;
const FacilitiesIcon = () => <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><polygon points="12 2 2 7 12 12 22 7 12 2"></polygon><polyline points="2 17 12 22 22 17"></polyline><polyline points="2 12 12 17 22 12"></polyline></svg>;
const LibraryIcon = () => <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20"></path><path d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z"></path></svg>;
const MediaIcon = () => <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><rect x="3" y="3" width="18" height="18" rx="2" ry="2"></rect><circle cx="8.5" cy="8.5" r="1.5"></circle><polyline points="21 15 16 10 5 21"></polyline></svg>;
const SettingsIcon = () => <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="12" cy="12" r="3"></circle><path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-2 2 2 2 0 0 1-2-2v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83 0 2 2 0 0 1 0-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1-2-2 2 2 0 0 1 2-2h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 0-2.83 2 2 0 0 1 2.83 0l.06.06a1.65 1.65 0 0 0 1.82.33h.09a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 2-2 2 2 0 0 1 2 2v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 0 2 2 0 0 1 0 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 2 2 2 2 0 0 1-2 2h-.09a1.65 1.65 0 0 0-1.51 1z"></path></svg>;
const GovernanceIcon = () => <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"></path></svg>;
const AdministrativeIcon = () => <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><rect x="2" y="7" width="20" height="14" rx="2" ry="2"></rect><path d="M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16"></path></svg>;
const CommitteesIcon = () => <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path><circle cx="9" cy="7" r="4"></circle><path d="M23 21v-2a4 4 0 0 0-3-3.87"></path><path d="M16 3.13a4 4 0 0 1 0 7.75"></path></svg>;
const ProgrammesIcon = () => <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M22 10v6M2 10l10-5 10 5-10 5z"></path><path d="M6 12v5c3 3 9 3 12 0v-5"></path></svg>;
const AdmissionsIcon = () => <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M16 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path><circle cx="8.5" cy="7" r="4"></circle><polyline points="17 11 19 13 23 9"></polyline></svg>;
const DepartmentIcon = () => <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><polygon points="12 2 2 7 12 12 22 7 12 2"></polygon><polyline points="2 17 12 22 22 17"></polyline><polyline points="2 12 12 17 22 12"></polyline></svg>;
const CareersIcon = () => <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><rect x="2" y="7" width="20" height="14" rx="2" ry="2"></rect><path d="M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16"></path></svg>;
const ContactIcon = () => <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"></path></svg>;

const ChevronIcon = () => <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><polyline points="6 9 12 15 18 9"></polyline></svg>;
const SubmenuDotIcon = () => <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="3"></circle></svg>;

const getIcon = (title) => {
  switch(title) {
    case "Dashboard": return DashboardIcon;
    case "About the College": return AboutIcon;
    case "Academics": return AcademicsIcon;
    case "Academic Programmes": return ProgrammesIcon;
    case "Admissions": return AdmissionsIcon;
    case "Department at a Glance": return DepartmentIcon;
    case "Examination": return ContentIcon;
    case "Facilities": return FacilitiesIcon;
    case "Library": return LibraryIcon;
    case "Media & Contact": return MediaIcon;
    case "Settings": return SettingsIcon;
    case "Governance": return GovernanceIcon;
    case "Administrative Authorities": return AdministrativeIcon;
    case "Committees": return CommitteesIcon;
    case "Media": return MediaIcon;
    case "Careers": return CareersIcon;
    case "Contact": return ContactIcon;
    default: return ContentIcon;
  }
};

const MenuNode = ({ item, collapsed, isNested }) => {
  const location = useLocation();
  const [open, setOpen] = useState(false);
  const [hovered, setHovered] = useState(false);
  const nodeRef = useRef(null);

  useEffect(() => {
    const isChildActive = (children) => {
      if (!children) return false;
      for (let child of children) {
        if (child.path === location.pathname) return true;
        if (child.children && isChildActive(child.children)) return true;
      }
      return false;
    };

    if (isChildActive(item.children)) {
      setOpen(true);
    }
  }, [location.pathname, item.children]);

  const IconRender = getIcon(item.title);

  // Flatten nested children for the popup to keep it clean
  const getFlatChildren = (children) => {
    let flat = [];
    children.forEach(child => {
      if (child.children) flat = [...flat, ...getFlatChildren(child.children)];
      else flat.push(child);
    });
    return flat;
  };

  const handleMouseEnter = () => collapsed && setHovered(true);
  const handleMouseLeave = () => collapsed && setHovered(false);

  if (item.children) {
    return (
      <li
        className="menuLi"
        ref={nodeRef}
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
        style={isNested ? { paddingLeft: '10px' } : {}}
      >
        <button
          className={`menuItem ${open && !collapsed ? 'submenuOpen' : ''} ${collapsed ? 'iconOnly' : ''}`}
          onClick={() => !collapsed && setOpen(!open)}
        >
          <div className="iconWrap">
            <IconRender />
          </div>
          {!collapsed && <span className="label">{item.title}</span>}
          {!collapsed && (
            <span className={`chevron ${open ? "chevronOpen" : ""}`}>
              <ChevronIcon />
            </span>
          )}
        </button>

        {/* Normal Expanded Submenu */}
        <ul className={`submenu ${open && !collapsed ? "submenuVisible" : ""}`}>
          {item.children.map((child, index) => {
            if (child.children) {
              return (
                <MenuNode key={index} item={child} collapsed={collapsed} isNested={true} />
              );
            }
            return (
              <li key={index}>
                <NavLink
                  to={child.path || "#"}
                  className={({ isActive }) => `submenuItem ${isActive ? "submenuActive" : ""}`}
                >
                  <div className="submenuDot" />
                  <span className="submenuLabel">{child.title}</span>
                </NavLink>
              </li>
            )
          })}
        </ul>

        {/* Floating Popup for Collapsed State */}
        {collapsed && hovered && (
          <div className="floatingPopup" style={{ top: nodeRef.current ? nodeRef.current.getBoundingClientRect().top : 0 }}>
            <div className="popupTitle">{item.title}</div>
            {getFlatChildren(item.children).map((child, idx) => (
              <NavLink
                key={idx}
                to={child.path || "#"}
                className={({ isActive }) => `popupItem ${isActive ? "popupItemActive" : ""}`}
              >
                <SubmenuDotIcon />
                {child.title}
              </NavLink>
            ))}
          </div>
        )}
      </li>
    );
  }

  return (
    <li
      className="menuLi"
      ref={nodeRef}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      style={isNested ? { paddingLeft: '10px' } : {}}
    >
      <NavLink
        to={item.path}
        className={({ isActive }) => `menuItem ${isActive ? "active" : ""} ${collapsed ? 'iconOnly' : ''}`}
      >
        <div className="iconWrap">
          <IconRender />
        </div>
        {!collapsed && <span className="label">{item.title}</span>}
      </NavLink>

      {collapsed && hovered && (
        <div className="floatingPopup" style={{ top: nodeRef.current ? nodeRef.current.getBoundingClientRect().top : 0 }}>
          <div className="popupTitle">Access</div>
          <div className="popupItem">
            {item.title}
          </div>
        </div>
      )}
    </li>
  );
};

const Sidebar = ({ mobileOpen, setMobileOpen, collapsed, setCollapsed }) => {
  const [dynamicCommittees, setDynamicCommittees] = useState([]);

  useEffect(() => {
    const fetchCommittees = async () => {
      try {
        const response = await fetch(`${dynamicCommitteesApi}/committees`);
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        
        const contentType = response.headers.get("content-type");
        if (contentType && contentType.indexOf("application/json") !== -1) {
          const result = await response.json();
          setDynamicCommittees(result.data || []);
        } else {
          throw new Error("Received non-JSON response from server");
        }
      } catch (error) {
        console.error("Error fetching dynamic committees for sidebar:", error);
      }
    };
    fetchCommittees();
  }, []);

  const augmentedSidebarData = useMemo(() => {
    const newData = JSON.parse(JSON.stringify(sidebarData)); // Deep copy
    
    // Find About the College -> Committees
    const aboutSection = newData.find(item => item.title === "About the College");
    if (aboutSection) {
      const committeesSection = aboutSection.children.find(child => child.title === "Committees");
      if (committeesSection) {
        // Add "Manage Committees" link at the top
        committeesSection.children.unshift({
          title: "Manage Committees",
          path: "/about/committees/manage"
        });

        // Add dynamic committees
        dynamicCommittees.forEach(committee => {
          committeesSection.children.push({
            title: committee.name,
            path: `/about/committees/dynamic/${committee._id}`
          });
        });
      }
    }
    return newData;
  }, [dynamicCommittees]);

  return (
    <>
      {mobileOpen && <div className="overlay" onClick={() => setMobileOpen(false)}></div>}

      <aside className={`sidebar ${collapsed ? "collapsed" : ""} ${mobileOpen ? "mobileOpen" : ""}`}>
        <div className="logo">
          {!collapsed && <div className="logoText">Admin Panel</div>}
        </div>

        <div className="nav">
          <ul className="menu">
            {augmentedSidebarData.map((item, index) => (
              <MenuNode key={index} item={item} collapsed={collapsed} />
            ))}
          </ul>
        </div>

        <button className="toggleBtn" onClick={() => setCollapsed(!collapsed)}>
          <svg style={{ transform: collapsed ? 'rotate(180deg)' : 'none', transition: 'all 0.3s' }} width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M11 17l-5-5 5-5M18 17l-5-5 5-5" /></svg>
        </button>
      </aside>
    </>
  );
};

export default Sidebar;
